import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { toggleFramesModal } from '../../actions/sidebar'
import PreviewFrame from './struct'

const mapStateToProps = state => ({
  isOpen: dotProp.get(state, 'sidebar.frames.modal.isOpen', false),
  picture: dotProp.get(state, 'sidebar.frames.modal.src', ''),
  sidebarOpen: dotProp.get(state, 'sidebar.isClosed', false),
})

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(toggleFramesModal('')),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PreviewFrame)



// WEBPACK FOOTER //
// ./src/containers/PreviewFrame/index.js